import $ from 'jquery';
import DEFAULTS from './defaults';

const cfProjectHero = window.cfProjectHero;

class CFAJAXHandler {
  constructor(options) {
    this.options = $.extend(true, {}, DEFAULTS, options);

    this.namespace = this.options.namespace;

    this.init();
  }

  init() {
    this.$body = $('body');
    this.$loaderContainer = this.options.loaderContainer;

    if (this.$loaderContainer && this.$loaderContainer.length) {
      this.$overlay = this.$loaderContainer.find('.cf-overlay');
      this.$loadingAnimation = this.$loaderContainer.find('.cf-loading-animation');
    }
  }

  /**
   * Resolve AJAX request.
   *
   * @returns {jqXHR}
   */
  resolve() {
    // Show loader.
    this.showLoader();

    return $.ajax({
      type: 'POST',
      dataType: 'json',
      url: this.options.ajaxUrl,
      data: this.options.data,
      complete: (xhr) => {
        let data = xhr.responseText;

        if (xhr.responseJSON) {
          data = xhr.responseJSON;
        }

        // Execute the onBeforeRedirect callback.
        if (typeof this.options.onBeforeRedirect === 'function') {
          this.options.onBeforeRedirect.call(this, data);
        }

        if (data.redirect_to) {
          window.location = data.redirect_to;
          return;
        }

        // Hide loader.
        this.hideLoader();

        // Update elements with content based on the selectors.
        if (data.update) {
          $.each(data.update, (selector, content) => {
            $(selector).html(content);
          });
        }

        // Remove elements based on the selectors.
        if (data.remove) {
          $.each(data.remove, (index, selector) => {
            $(selector).remove();
          });
        }

        // Replace elements with content based on the selectors.
        if (data.replaceWith) {
          $.each(data.replaceWith, (selector, content) => {
            $(selector).replaceWith(content);
          });
        }

        // Show elements based on the selectors.
        if (data.show) {
          $.each(data.show, (index, selector) => {
            $(selector).show();
          });
        }

        // Hide elements based on the selectors.
        if (data.hide) {
          $.each(data.hide, (index, selector) => {
            $(selector).hide();
          });
        }

        // Add classes to elements based on the selectors.
        if (data.addClass) {
          $.each(data.addClass, (selector, classes) => {
            $(selector).addClass(classes);
          });
        }

        // Removed classes from elements based on the selectors.
        if (data.removeClass) {
          $.each(data.removeClass, (selector, classes) => {
            $(selector).removeClass(classes);
          });
        }

        if (data.execute) {
          data.execute.forEach((execute) => {
            // Allow fn to be a function object or the name of a global function.
            const fn = (typeof execute.function === 'function') ? execute.function : window[execute.function];
            fn.apply(this, execute.args || []);
          });
        }

        // Execute the onComplete callback.
        if (typeof this.options.onComplete === 'function') {
          this.options.onComplete.call(this, data);
        }
      },
    });
  }

  showLoader() {
    this.$body.css('cursor', 'wait');

    if (this.$overlay && this.$overlay.length) {
      // Show existing overlay.
      this.$overlay.removeClass('d-none');
    } else if (this.$loaderContainer && this.$loaderContainer.length) {
      // Create and append overlay.
      this.$overlay = $('<div class="cf-overlay"></div>');
      this.$loaderContainer.append(this.$overlay);
    }

    if (this.$loadingAnimation && this.$loadingAnimation.length) {
      // Show existing loading animation.
      this.$loadingAnimation.removeClass('d-none');
    } else if (this.$loaderContainer && this.$loaderContainer.length) {
      // Create and append loading animation.
      this.$loadingAnimation = $(`<i class="cf-loading-animation">${cfProjectHero.textLoading}</i>`);
      this.$loaderContainer.append(this.$loadingAnimation);
    }
  }

  hideLoader() {
    this.$body.css('cursor', 'default');

    // Hide overlay and loading animation.
    if (typeof this.$overlay !== 'undefined') {
      this.$overlay.addClass('d-none');
    }

    if (typeof this.$loadingAnimation !== 'undefined') {
      this.$loadingAnimation.addClass('d-none');
    }
  }

  static setDefaults(options) {
    $.extend(true, DEFAULTS, $.isPlainObject(options) && options);
  }
}

export default CFAJAXHandler;



// WEBPACK FOOTER //
// ./assets/js/cf-ajax-handler/CFAJAXHandler.js